/** The default toast z index */
export const TOAST_Z_INDEX = 1000;
/** The default toast timeout index */
export const TOAST_TIMEOUT = 4000;
/** The default toast limit index */
export const TOAST_LIMIT = 5;
/** The default toast position index */
export const TOAST_POSITION = "bottom-right";
